import Loading from '@/components/common/qLoading.vue'

const Plugin = {
  install(Vue, options = {}) {

    if (Vue.prototype.$qLoading) {
      return
    }

    const plugin = new PluginCore(Vue, options)
    
    
    Object.defineProperty(Vue.prototype, '$qLoading', {
      get: function() {

        const caller = this

        if (caller instanceof Vue) {
           const root = caller.$root

          if (!plugin.context.root) {
            plugin.setCreateLoading(root)
          }
        }

        return plugin
      }
    })
  }
}

const PluginCore = (Vue, options = {}) => {
  let LoadingIsShow = false;
  const context = {
    root: null,
    componentName: options.componentName || 'qLoading',
    vuecom:null
  }

  /**
   * Creates a container for modals in the root Vue component.
   *
   * @param {Vue} parent
   */

  const setCreateLoading = parent => {
    context.root = parent

    const divelement = document.createElement('div')
    document.body.appendChild(divelement)
    
    const vuecomponent = new Vue({
      parent,
      render: h => h(Loading)
    }).$mount(divelement)

    const MapResult = vuecomponent.$children.map(compo => {
      const MatchResult = compo.$vnode.tag.match(context.componentName) ?? "none"
      return MatchResult == "none" ? null : compo;
    })

    context.vuecom = MapResult == null ? null : MapResult[0];
  }

  const show = () => {
    if(context.vuecom && !LoadingIsShow) {
      LoadingIsShow = !LoadingIsShow;
      context.vuecom.show();
    }
  }

  const hide = () => {
    if(context.vuecom && LoadingIsShow) {
      LoadingIsShow = !LoadingIsShow;
      context.vuecom.stop();
    }
  }
  
  const isshow = LoadingIsShow;

  return {
    context,
    show,
    hide,
    isshow,
    setCreateLoading
  }
}


export default Plugin